import { z } from 'zod';
// =========================================================
// Schemas Zod para GET /api/batches/kpis.
//
// Query params:
//   - desde: YYYY-MM-DD (requerido)
//   - hasta: YYYY-MM-DD (requerido)
//   - id_planta: número (opcional)
//
// Validación de rango: máximo 90 días (incluyente).
// =========================================================
const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;
const ISO_DATE_TEXTO = z
    .string()
    .regex(ISO_DATE, 'Formato esperado YYYY-MM-DD')
    .refine((s) => !Number.isNaN(new Date(s).getTime()), 'Fecha inválida');
export const RANGO_MAXIMO_DIAS = 90;
/**
 * Request del endpoint de KPIs (query string).
 *
 * `id_planta` viene como string desde la URL — la coercemos a número. Si no
 * está presente, queda `undefined` (significa "todas las plantas").
 */
export const KpisRequestSchema = z
    .object({
    desde: ISO_DATE_TEXTO,
    hasta: ISO_DATE_TEXTO,
    id_planta: z.coerce.number().int().positive().optional(),
})
    .refine(({ desde, hasta }) => new Date(hasta).getTime() >= new Date(desde).getTime(), {
    message: '`hasta` debe ser >= `desde`',
    path: ['hasta'],
})
    .refine(({ desde, hasta }) => {
    const dias = (new Date(hasta).getTime() - new Date(desde).getTime()) / (1000 * 60 * 60 * 24);
    return dias <= RANGO_MAXIMO_DIAS;
}, { message: `Rango máximo ${RANGO_MAXIMO_DIAS} días`, path: ['hasta'] });
export const M3PorDiaSchema = z.object({
    /** YYYY-MM-DD, UTC. */
    fecha: z.string().regex(ISO_DATE),
    /** Total del día (suma de todas las plantas). */
    m3: z.number().nonnegative(),
    /**
     * Desglose por planta. Key = `planta_nombre` (ej. "Bianca E50"),
     * value = m³ del día para esa planta. Se llena solo cuando hay
     * actividad de más de una planta — el frontend usa esto para
     * renderizar líneas separadas con color por planta.
     *
     * Cuando el filtro de planta está fijado a una específica, sigue
     * apareciendo el desglose (con esa única planta) por consistencia.
     */
    m3_por_planta: z.record(z.string(), z.number().nonnegative()).default({}),
});
export const KpisResponseSchema = z.object({
    total_batches: z.number().int().nonnegative(),
    total_m3: z.number().nonnegative(),
    pct_con_alarma: z.number().min(0).max(100),
    pct_receta_modificada: z.number().min(0).max(100),
    /** Serie diaria con gap-filling: incluye TODOS los días del rango. */
    m3_por_dia: z.array(M3PorDiaSchema),
});
//# sourceMappingURL=kpis.js.map